import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 8px 10px;
  border: 1.5px solid #d2d2d7;
  border-radius: 10px;
  margin: 4px 0px;
  transition: border-color 0.2s;
  &:focus-within {
    border-color: #007aff;
  }
`;

const Container = styled.input`
  width: 100%;
  font-family: inherit;
  font-size: 14px;
  outline: none;
  border: none;
  color: #1d1d1f;
  ::placeholder {
    color: #86868b;
  }
`;

const TextLine = ({ height, type, name, value, placeholder, onChange }) => {
  return (
    <Wrapper>
      <Container style={{ height: height }} type={type} name={name} value={value} onChange={onChange} placeholder={placeholder || "가격을 입력해주세요."} />
    </Wrapper>
  );
};

export default TextLine;